export default __webpack_public_path__ + "static/media/no-check.24648b75.svg";